"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import {
  isPostHogExcludedPath,
  resumePostHogCapturing,
  silencePostHogForExcludedPath,
} from "@/lib/analytics";

/**
 * Initialises PostHog on the client (once) and renders its children. We drive
 * events through the helpers in @/lib/analytics rather than the usePostHog hook,
 * so no React context is required — this wrapper just guarantees init runs.
 * Internal /metrics never boots PostHog; if we already had a session and the
 * user navigates here, capturing is opted out until they leave.
 */
export function PostHogProvider({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  useEffect(() => {
    if (isPostHogExcludedPath(pathname)) {
      silencePostHogForExcludedPath();
      return;
    }
    resumePostHogCapturing();
  }, [pathname]);
  return <>{children}</>;
}
